<div>
  <button (click)="createTable()" type="button" class="btn btn-add-table">Добавить стол №{{ nextTableNumber }}</button>
</div>
